<template>
  <div class="settings-container">
    <div class="page-header">
      <h2>系统设置</h2>
    </div>

    <el-card class="settings-card">
      <el-tabs v-model="activeTab" tab-position="left">
        <!-- 基本设置 -->
        <el-tab-pane label="基本设置" name="basic">
          <div class="settings-content">
            <div class="section-title">系统基本设置</div>
            <el-form ref="basicForm" :model="basicForm" :rules="basicRules" label-width="150px" style="max-width: 600px;">
              <el-form-item label="系统名称" prop="system_name">
                <el-input v-model="basicForm.system_name" placeholder="请输入系统名称" />
              </el-form-item>
              <el-form-item label="系统Logo" prop="system_logo">
                <el-input v-model="basicForm.system_logo" placeholder="请输入Logo地址">
                  <el-button slot="append" icon="el-icon-upload" @click="handleUploadLogo">上传</el-button>
                </el-input>
              </el-form-item>
              <el-form-item label="系统版本" prop="system_version">
                <el-input v-model="basicForm.system_version" placeholder="请输入系统版本" />
              </el-form-item>
              <el-form-item label="版权信息" prop="copyright">
                <el-input v-model="basicForm.copyright" placeholder="请输入版权信息" />
              </el-form-item>
              <el-form-item label="备案号" prop="icp">
                <el-input v-model="basicForm.icp" placeholder="请输入备案号" />
              </el-form-item>
              <el-form-item label="联系邮箱" prop="contact_email">
                <el-input v-model="basicForm.contact_email" placeholder="请输入联系邮箱" />
              </el-form-item>
              <el-form-item label="联系电话" prop="contact_phone">
                <el-input v-model="basicForm.contact_phone" placeholder="请输入联系电话" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSaveBasic">保存设置</el-button>
                <el-button @click="resetBasicForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 安全设置 -->
        <el-tab-pane label="安全设置" name="security">
          <div class="settings-content">
            <div class="section-title">安全设置</div>
            <el-form ref="securityForm" :model="securityForm" label-width="180px" style="max-width: 600px;">
              <el-form-item label="启用登录验证码">
                <el-switch v-model="securityForm.enable_captcha" />
                <div class="form-tip">开启后，登录时需要输入验证码</div>
              </el-form-item>
              <el-form-item label="密码最小长度">
                <el-input-number v-model="securityForm.password_min_length" :min="6" :max="20" />
                <div class="form-tip">设置用户密码的最小长度（6-20位）</div>
              </el-form-item>
              <el-form-item label="密码过期天数">
                <el-input-number v-model="securityForm.password_expire_days" :min="0" :max="365" />
                <div class="form-tip">设置为0表示永不过期</div>
              </el-form-item>
              <el-form-item label="登录失败锁定次数">
                <el-input-number v-model="securityForm.login_fail_lock_count" :min="0" :max="10" />
                <div class="form-tip">连续登录失败达到此次数后锁定账号，设置为0表示不锁定</div>
              </el-form-item>
              <el-form-item label="账号锁定时长（分钟）">
                <el-input-number v-model="securityForm.lock_duration" :min="5" :max="1440" />
              </el-form-item>
              <el-form-item label="会话超时时间（分钟）">
                <el-input-number v-model="securityForm.session_timeout" :min="10" :max="1440" />
                <div class="form-tip">用户无操作超过此时间后自动退出登录</div>
              </el-form-item>
              <el-form-item label="启用IP白名单">
                <el-switch v-model="securityForm.enable_ip_whitelist" />
                <div class="form-tip">开启后，只有白名单内的IP可以访问系统</div>
              </el-form-item>
              <el-form-item label="IP白名单" v-if="securityForm.enable_ip_whitelist">
                <el-input 
                  v-model="securityForm.ip_whitelist" 
                  type="textarea" 
                  :rows="4" 
                  placeholder="每行一个IP地址或IP段，例如：192.168.1.1 或 192.168.1.0/24"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSaveSecurity">保存设置</el-button>
                <el-button @click="resetSecurityForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 邮件设置 -->
        <el-tab-pane label="邮件设置" name="email">
          <div class="settings-content">
            <div class="section-title">邮件服务器设置</div>
            <el-form ref="emailForm" :model="emailForm" :rules="emailRules" label-width="150px" style="max-width: 600px;">
              <el-form-item label="SMTP服务器" prop="smtp_host">
                <el-input v-model="emailForm.smtp_host" placeholder="例如：smtp.qq.com" />
              </el-form-item>
              <el-form-item label="SMTP端口" prop="smtp_port">
                <el-input-number v-model="emailForm.smtp_port" :min="1" :max="65535" />
              </el-form-item>
              <el-form-item label="发件人邮箱" prop="from_email">
                <el-input v-model="emailForm.from_email" placeholder="请输入发件人邮箱" />
              </el-form-item>
              <el-form-item label="发件人名称" prop="from_name">
                <el-input v-model="emailForm.from_name" placeholder="请输入发件人名称" />
              </el-form-item>
              <el-form-item label="邮箱账号" prop="email_account">
                <el-input v-model="emailForm.email_account" placeholder="请输入邮箱账号" />
              </el-form-item>
              <el-form-item label="邮箱密码" prop="email_password">
                <el-input v-model="emailForm.email_password" type="password" placeholder="请输入邮箱密码或授权码" show-password />
              </el-form-item>
              <el-form-item label="启用SSL">
                <el-switch v-model="emailForm.enable_ssl" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSaveEmail">保存设置</el-button>
                <el-button @click="handleTestEmail">发送测试邮件</el-button>
                <el-button @click="resetEmailForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 短信设置 -->
        <el-tab-pane label="短信设置" name="sms">
          <div class="settings-content">
            <div class="section-title">短信服务设置</div>
            <el-form ref="smsForm" :model="smsForm" :rules="smsRules" label-width="150px" style="max-width: 600px;">
              <el-form-item label="短信服务商" prop="sms_provider">
                <el-select v-model="smsForm.sms_provider" placeholder="请选择短信服务商">
                  <el-option label="阿里云" value="aliyun" />
                  <el-option label="腾讯云" value="tencent" />
                  <el-option label="华为云" value="huawei" />
                </el-select>
              </el-form-item>
              <el-form-item label="AccessKey ID" prop="access_key_id">
                <el-input v-model="smsForm.access_key_id" placeholder="请输入AccessKey ID" />
              </el-form-item>
              <el-form-item label="AccessKey Secret" prop="access_key_secret">
                <el-input v-model="smsForm.access_key_secret" type="password" placeholder="请输入AccessKey Secret" show-password />
              </el-form-item>
              <el-form-item label="短信签名" prop="sms_sign">
                <el-input v-model="smsForm.sms_sign" placeholder="请输入短信签名" />
              </el-form-item>
              <el-form-item label="验证码模板ID" prop="code_template_id">
                <el-input v-model="smsForm.code_template_id" placeholder="请输入验证码模板ID" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSaveSms">保存设置</el-button>
                <el-button @click="handleTestSms">发送测试短信</el-button>
                <el-button @click="resetSmsForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 存储设置 -->
        <el-tab-pane label="存储设置" name="storage">
          <div class="settings-content">
            <div class="section-title">文件存储设置</div>
            <el-form ref="storageForm" :model="storageForm" label-width="150px" style="max-width: 600px;">
              <el-form-item label="存储方式">
                <el-radio-group v-model="storageForm.storage_type">
                  <el-radio label="local">本地存储</el-radio>
                  <el-radio label="oss">阿里云OSS</el-radio>
                  <el-radio label="cos">腾讯云COS</el-radio>
                  <el-radio label="qiniu">七牛云</el-radio>
                </el-radio-group>
              </el-form-item>

              <!-- 本地存储配置 -->
              <template v-if="storageForm.storage_type === 'local'">
                <el-form-item label="存储路径">
                  <el-input v-model="storageForm.local_path" placeholder="例如：/uploads" />
                </el-form-item>
                <el-form-item label="访问域名">
                  <el-input v-model="storageForm.local_domain" placeholder="例如：https://www.example.com" />
                </el-form-item>
              </template>

              <!-- 云存储配置 -->
              <template v-if="storageForm.storage_type !== 'local'">
                <el-form-item label="AccessKey ID">
                  <el-input v-model="storageForm.cloud_access_key_id" placeholder="请输入AccessKey ID" />
                </el-form-item>
                <el-form-item label="AccessKey Secret">
                  <el-input v-model="storageForm.cloud_access_key_secret" type="password" placeholder="请输入AccessKey Secret" show-password />
                </el-form-item>
                <el-form-item label="Bucket名称">
                  <el-input v-model="storageForm.cloud_bucket" placeholder="请输入Bucket名称" />
                </el-form-item>
                <el-form-item label="地域节点">
                  <el-input v-model="storageForm.cloud_region" placeholder="例如：oss-cn-hangzhou" />
                </el-form-item>
                <el-form-item label="访问域名">
                  <el-input v-model="storageForm.cloud_domain" placeholder="请输入自定义域名或默认域名" />
                </el-form-item>
              </template>

              <el-form-item label="允许上传类型">
                <el-input v-model="storageForm.allowed_extensions" placeholder="例如：jpg,png,gif,pdf" />
                <div class="form-tip">多个类型用逗号分隔</div>
              </el-form-item>
              <el-form-item label="最大文件大小(MB)">
                <el-input-number v-model="storageForm.max_file_size" :min="1" :max="100" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSaveStorage">保存设置</el-button>
                <el-button @click="resetStorageForm">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>

        <!-- 系统维护 -->
        <el-tab-pane label="系统维护" name="maintenance">
          <div class="settings-content">
            <div class="section-title">系统维护</div>
            
            <el-card class="maintenance-card">
              <div slot="header">
                <span>缓存管理</span>
              </div>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="maintenance-item">
                    <div class="item-title">清除系统缓存</div>
                    <div class="item-desc">清除系统运行产生的临时缓存数据</div>
                    <el-button type="primary" size="small" @click="handleClearCache">清除缓存</el-button>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="maintenance-item">
                    <div class="item-title">清除日志文件</div>
                    <div class="item-desc">清除系统运行日志文件（保留最近7天）</div>
                    <el-button type="warning" size="small" @click="handleClearLogs">清除日志</el-button>
                  </div>
                </el-col>
              </el-row>
            </el-card>

            <el-card class="maintenance-card">
              <div slot="header">
                <span>数据备份</span>
              </div>
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="maintenance-item">
                    <div class="item-title">数据库备份</div>
                    <div class="item-desc">备份当前数据库数据</div>
                    <el-button type="primary" size="small" @click="handleBackupDatabase">立即备份</el-button>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="maintenance-item">
                    <div class="item-title">查看备份记录</div>
                    <div class="item-desc">查看历史备份文件列表</div>
                    <el-button type="info" size="small" @click="handleViewBackups">查看记录</el-button>
                  </div>
                </el-col>
              </el-row>
            </el-card>

            <el-card class="maintenance-card">
              <div slot="header">
                <span>系统信息</span>
              </div>
              <div class="system-info">
                <div class="info-row">
                  <span class="info-label">系统版本：</span>
                  <span class="info-value">v1.0.0</span>
                </div>
                <div class="info-row">
                  <span class="info-label">PHP版本：</span>
                  <span class="info-value">{{ systemInfo.php_version || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">数据库版本：</span>
                  <span class="info-value">{{ systemInfo.mysql_version || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">服务器系统：</span>
                  <span class="info-value">{{ systemInfo.os || '-' }}</span>
                </div>
                <div class="info-row">
                  <span class="info-label">运行时间：</span>
                  <span class="info-value">{{ systemInfo.uptime || '-' }}</span>
                </div>
              </div>
            </el-card>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import {
  getSettings,
  saveSettings,
  clearCache,
  testEmail,
  testSms,
  getSystemInfo
} from '@/api/setting'
import { uploadImage } from '@/api/upload'

export default {
  name: 'Settings',
  data() {
    return {
      activeTab: 'basic',
      basicForm: {
        system_name: '后台管理系统',
        system_logo: '',
        system_version: 'v1.0.0',
        copyright: 'Copyright © 2024',
        icp: '',
        contact_email: '',
        contact_phone: ''
      },
      basicRules: {
        system_name: [
          { required: true, message: '请输入系统名称', trigger: 'blur' }
        ]
      },
      securityForm: {
        enable_captcha: true,
        password_min_length: 6,
        password_expire_days: 90,
        login_fail_lock_count: 5,
        lock_duration: 30,
        session_timeout: 120,
        enable_ip_whitelist: false,
        ip_whitelist: ''
      },
      emailForm: {
        smtp_host: '',
        smtp_port: 465,
        from_email: '',
        from_name: '',
        email_account: '',
        email_password: '',
        enable_ssl: true
      },
      emailRules: {
        smtp_host: [
          { required: true, message: '请输入SMTP服务器', trigger: 'blur' }
        ],
        from_email: [
          { required: true, message: '请输入发件人邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      smsForm: {
        sms_provider: 'aliyun',
        access_key_id: '',
        access_key_secret: '',
        sms_sign: '',
        code_template_id: ''
      },
      smsRules: {
        sms_provider: [
          { required: true, message: '请选择短信服务商', trigger: 'change' }
        ]
      },
      storageForm: {
        storage_type: 'local',
        local_path: '/uploads',
        local_domain: '',
        cloud_access_key_id: '',
        cloud_access_key_secret: '',
        cloud_bucket: '',
        cloud_region: '',
        cloud_domain: '',
        allowed_extensions: 'jpg,jpeg,png,gif,pdf,doc,docx,xls,xlsx',
        max_file_size: 10
      },
      systemInfo: {
        php_version: '7.4.0',
        mysql_version: '5.7.30',
        os: 'Linux',
        uptime: '15天3小时'
      }
    }
  },
  created() {
    this.loadSettings()
    this.loadSystemInfo()
  },
  methods: {
    async loadSettings() {
      try {
        const res = await getSettings({ group: '' })
        if (res.code === 200) {
          Object.assign(this.basicForm, res.data.basic || {})
          Object.assign(this.securityForm, res.data.security || {})
          Object.assign(this.emailForm, res.data.email || {})
          Object.assign(this.smsForm, res.data.sms || {})
          Object.assign(this.storageForm, res.data.storage || {})
        }
      } catch (error) {
        console.error('加载设置失败', error)
      }
    },

    async saveSettingsData() {
      const settings = {
        basic: this.basicForm,
        security: this.securityForm,
        email: this.emailForm,
        sms: this.smsForm,
        storage: this.storageForm
      }

      try {
        await saveSettings({ settings })
        this.$message.success('保存成功')
      } catch (error) {
        console.error('保存失败', error)
        this.$message.error('保存失败')
      }
    },

    handleSaveBasic() {
      this.$refs.basicForm.validate((valid) => {
        if (valid) {
          this.saveSettingsData()
        }
      })
    },

    resetBasicForm() {
      this.$refs.basicForm.resetFields()
    },

    handleUploadLogo() {
      // 创建隐藏的文件输入元素
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.style.display = 'none'

      input.onchange = (e) => {
        const file = e.target.files[0]
        if (!file) return

        // 验证文件类型
        if (!file.type.startsWith('image/')) {
          this.$message.error('请选择图片文件')
          return
        }

        // 验证文件大小（限制2MB）
        if (file.size > 2 * 1024 * 1024) {
          this.$message.error('图片大小不能超过2MB')
          return
        }

        // 显示上传进度
        const loading = this.$loading({
          lock: true,
          text: '上传中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 调用上传API
        uploadImage(file, 'settings/logo')
          .then(res => {
            if (res.code === 200) {
              // 更新logo地址
              this.basicForm.system_logo = res.data.url || res.data
              this.$message.success('Logo上传成功')
            } else {
              this.$message.error(res.message || '上传失败')
            }
          })
          .catch(err => {
            console.error('上传失败', err)
            this.$message.error(err.message || '上传失败')
          })
          .finally(() => {
            loading.close()
            // 移除输入元素
            document.body.removeChild(input)
          })
      }

      // 将输入元素添加到文档并触发点击
      document.body.appendChild(input)
      input.click()
    },

    handleSaveSecurity() {
      this.saveSettingsData()
    },

    resetSecurityForm() {
      this.$refs.securityForm.resetFields()
    },

    handleSaveEmail() {
      this.$refs.emailForm.validate((valid) => {
        if (valid) {
          this.saveSettingsData()
        }
      })
    },

    handleTestEmail() {
      this.$prompt('请输入测试邮箱地址', '发送测试邮件', {
        confirmButtonText: '发送',
        cancelButtonText: '取消',
        inputPattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        testEmail({ email: value }).then(() => {
          this.$message.success(`测试邮件已发送到 ${value}`)
        }).catch(err => {
          this.$message.error(err.message || '发送失败')
        })
      }).catch(() => {})
    },

    resetEmailForm() {
      this.$refs.emailForm.resetFields()
    },

    handleSaveSms() {
      this.$refs.smsForm.validate((valid) => {
        if (valid) {
          this.saveSettingsData()
        }
      })
    },

    handleTestSms() {
      this.$prompt('请输入测试手机号', '发送测试短信', {
        confirmButtonText: '发送',
        cancelButtonText: '取消',
        inputPattern: /^1[3-9]\d{9}$/,
        inputErrorMessage: '手机号格式不正确'
      }).then(({ value }) => {
        testSms({ mobile: value }).then(() => {
          this.$message.success(`测试短信已发送到 ${value}`)
        }).catch(err => {
          this.$message.error(err.message || '发送失败')
        })
      }).catch(() => {})
    },

    resetSmsForm() {
      this.$refs.smsForm.resetFields()
    },

    handleSaveStorage() {
      this.saveSettingsData()
    },

    resetStorageForm() {
      this.$refs.storageForm.resetFields()
    },

    async handleClearCache() {
      try {
        await clearCache()
        this.$message.success('缓存清除成功')
      } catch (error) {
        this.$message.error('清除失败')
      }
    },

    handleClearLogs() {
      this.$confirm('确定要清除日志文件吗？此操作不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('日志清除成功')
      }).catch(() => {})
    },

    handleBackupDatabase() {
      this.$confirm('确定要备份数据库吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.$message.success('数据库备份成功')
      }).catch(() => {})
    },

    handleViewBackups() {
      this.$message.info('备份记录功能开发中...')
    },

    async loadSystemInfo() {
      try {
        const res = await getSystemInfo()
        if (res) {
          this.systemInfo = res
        }
      } catch (error) {
        console.error('获取系统信息失败', error)
      }
    }
  }
}
</script>

<style scoped>
.settings-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 24px;
  color: #303133;
}

.settings-card {
  background: #fff;
  min-height: 600px;
}

.settings-content {
  padding: 20px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
  padding-left: 10px;
  border-left: 4px solid #409EFF;
  line-height: 20px;
}

.form-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  line-height: 1.5;
}

.maintenance-card {
  margin-bottom: 20px;
}

.maintenance-item {
  padding: 15px;
  border: 1px solid #EBEEF5;
  border-radius: 4px;
  background: #FAFAFA;
}

.item-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.item-desc {
  font-size: 12px;
  color: #606266;
  margin-bottom: 12px;
  line-height: 1.5;
}

.system-info {
  padding: 10px 0;
}

.info-row {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid #EBEEF5;
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  width: 150px;
  color: #606266;
  font-weight: 500;
}

.info-value {
  flex: 1;
  color: #303133;
}
</style>

